import React from 'react'
import InvoiceProcessing from '../components/InvoiceProcessing'

const InvoicesPage: React.FC = () => {
	return <InvoiceProcessing />
}

export default InvoicesPage

